import "./MenuGallery.scss";

type GalleryImage = {
  src: string;
  alt: string;
};

type MenuGalleryProps = {
  image1: GalleryImage;
  image2: GalleryImage;
  image3: GalleryImage;
  image4: GalleryImage;
};

function MenuGallery({ image1, image2, image3, image4 }: MenuGalleryProps) {
  return (
    <section className="menu-gallery">
      <img src={image1.src} alt={image1.alt} className="menu-gallery__img" />
      <img src={image2.src} alt={image2.alt} className="menu-gallery__img" />
      <img src={image3.src} alt={image3.alt} className="menu-gallery__img" />
      <img src={image4.src} alt={image4.alt} className="menu-gallery__img" />
    </section>
  );
}

export default MenuGallery;
